// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
  min-height: 400px;
}

.my-video-draft p {
  padding: 15px 0 0 0;
  color: rgba(136, 133, 142, 1);
}

.my-video-draft .tab-box-video {
  width: 100%;
  margin-top: 20px;
}

.my-video-draft .tab-box-video ul {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.my-video-draft .tab-box-video ul li {
  list-style: none;
  font-weight: 500;
  font-size: 18px;
  padding: 5px 0;
  margin: 0px 25px;
  color: #878395;
  cursor: pointer;
}

::ng-deep .createBadge {
  overflow: auto !important;
}

.my-video-draft .tab-box-video ul li.active {
  border-top: 3px solid rgba(108, 47, 187, 1);
  color: rgba(108, 47, 187, 1);
}

.folderImg {
  object-fit: contain !important;
}

.example-card {
  margin: 1rem 0 0.5rem 0;
  cursor: pointer;
}

.selected-video {
  border: 2px solid #6e5eff;
  border-radius: 5px;
}

.addPathVideos {
  text-align: end;
}

.addPathVideos button{
  border: 1px solid #6e5eff;
  padding: 8px 30px;
  border-radius: 5px;
  color: #ffff;
  font-size: 15px;
  cursor: pointer;
  outline: none;
  background: #6e5eff;
}

.selected-video .check-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 999999;
  color: #6e5eff;
  font-size: 36px;
  background-color: white;
  border-radius: 100%;
}

ol li {
  font-size: 18px;
}

.breadcrumb-item.active {
  color: #6c2fbb !important;
  font-weight: 500;
}

.firstLi {
  cursor: pointer;
}

.docCard {
  width: 190px;
}

.docCard img {
  width: 190px;
  height: 175px;
  margin: 0;
  touch-action: auto !important;
}

.docCard p {
  text-align: center;
  padding: 2px;
  cursor: text;
  font-weight: 500;
  font-size: 15px;
  color: #000;
}

.example-full-width {
  width: 100%;
}

mat-card img {
  object-fit: cover;
  height: 165px;
}

.contain {
  object-fit: contain !important;
}

.video-title {
  word-break: break-word;
  font: 400 14px/20px Roboto, "Helvetica Neue", sans-serif;
  margin-bottom: 0 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#vid-search-btn {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 9;
}

.select-vid-area {
  border: 1px dotted black;
  border-radius: 10px;
  padding: 28px 15px;
}

.video-duration {
  position: absolute;
  left: 0;
  top: 0;
  background: lightgray;
  padding-left: 4px;
  padding-right: 4px;
  color: black;
  z-index: 1;
}

.FF-scroll-modify {
  max-height: 600px;
  height: auto;
  overflow-x: hidden;
  overflow-y: scroll;
}

.selected-item {
  background-color: #ccc;
  padding: 0px 21px;
  height: 224px;
}

.button-style-dropdown {
  border: 1px solid #6e5eff;
  padding: 8px 30px;
  border-radius: 5px;
  color: #ffff;
  font-size: 15px;
  display: block;
  width: 100%;
  margin: 0 auto;
  cursor: pointer;
  position: relative;
  outline: none;
  background: #6e5eff;
  text-align: center;
}

.btnUpload{
    padding: 6px 10px !important;
}

.button-style-dropdown input {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  cursor: pointer;
}

.preview-card {
  width: 100%;
  margin-bottom: 8px;
  cursor: pointer;
}

.preview-card img {
  height: 150px;
  width: 200px;
}

.btn-mania {
  display: flex;
  align-items: center;
  justify-content: center;
  /*flex-wrap: wrap;*/
  gap: 10px;
  max-width: 360px;
  /*margin: 30px auto 0;*/
  margin: 0px auto 0;
}

.btn-mania button {
  color: #6c2fbb;
  border: 1px solid #6c2fbb;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
  background: #FFFFFF;
  border-radius: 11px;
  white-space: nowrap;
}

.cardForQue{
  display: flex;
  justify-content: center;
  padding: 20px;
}

.cardForQue .badgeBoxForQue{
    display: flex;
    justify-content: center;
    margin: auto;
    align-items: center;
}

.mat-mdc-card-content:last-child{
  padding: 0;
}

.cardForAIVideo{
  cursor: inherit;
}

@media (max-width: 1199px) {
  .videosModal>div {
    padding-inline: 4px;
  }

  .videosModal>div .button-style-dropdown {
    padding: 6px 5px;
  }
}

@media only screen and (max-width: 991px) and (min-width: 768px)  {
  ::ng-deep .recordSection {
    max-width: 100% !important;
    margin: auto;
    display: flex;
    width: 65% !important;
    justify-content: center;
  }
}

@media only screen and (max-width: 767px) and (min-width: 0px)  {
  ::ng-deep .recordSection {
    max-width: 100% !important;
    margin: auto;
    display: flex;
    width: 90% !important;
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .my-video-draft .tab-box-video ul li {
    font-size: 17px;
  }

  .my-video-draft p {
    font-size: 15px;
  }
}

.privacy-text {
  position: absolute;
  /*left: 0;*/
  top: 0;
}

mat-dialog-content {
  overflow: hidden;
}

mat-dialog-content .FF-scroll-modify {
  max-height: 350px;
}

@media (max-width: 720px) {
  .videosModal {
    flex-direction: column;
    gap: 10px;
  }
}

@media only screen and (max-width: 575px) and (min-width: 320px) {
  mat-dialog-content {
    padding: 0 10px;
    margin: 0;
  }

  .videosModal {
    gap: 10px;
    display: flex;
    flex-direction: column;
  }

  .videosModal .col-md-4 {
    padding: 0;
  }

  .documents-scroll {
    justify-content: center;
  }

  ::ng-deep .my-dialog {
    width: 100% !important;
    max-width: 95vw !important;
  }

  .mainSection {
    gap: 10px;
  }
}

@media (max-width: 420px) {
  ::ng-deep .recordSection .mat-dialog-container {
    padding: 14px;
  }

  ::ng-deep .recordSection .mat-dialog-container .custom-control label:first-child {
    font-size: 14px;
  }

  .my-video-draft .tab-box-video ul li {
    margin: 0px 18px;
  }
}



/* Custom tooltip css start */
.wrapper {
    position: relative;
    -webkit-transform: translateZ(0);
    -webkit-font-smoothing: antialiased;
    z-index: 2;
}

.wrapper .tooltip {
  background: #505259eb;
  bottom: 100%;
  color: #fff;
  display: block;
  left: -20px;
  margin-bottom: 15px;
  opacity: 0;
  padding: 10px;
  pointer-events: none;
  position: absolute;
  width: 100%;
  transform: translateY(10px);
  transition: all .25s ease-out;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
  border-radius: 6px;
  z-index: 1;
}

.wrapper .tooltip:before {
  bottom: -20px;
  content: " ";
  display: block;
  height: 20px;
  left: 0;
  position: absolute;
  width: 100%;
}

.wrapper .tooltip:after {
  border-left: solid transparent 10px;
  border-right: solid transparent 10px;
  border-top: solid #505259eb 10px;
  bottom: -10px;
  content: " ";
  height: 0;
  left: 50%;
  margin-left: -13px;
  position: absolute;
  width: 0;
}

.wrapper:hover .tooltip {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0px);
}

.lte8 .wrapper .tooltip {
  display: none;
}

.lte8 .wrapper:hover .tooltip {
  display: block;
}

/* Custom tooltip css end */`, "",{"version":3,"sources":["webpack://./src/app/layout/modals/create-video/create-video.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,wDAAwD;EACxD,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;AACR;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,SAAS;IACT,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;;;AAIA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,gCAAgC;IAChC,mCAAmC;IACnC,UAAU;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;EAC7B,2CAA2C;EAC3C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,gCAAgC;EAChC,aAAa;EACb,YAAY;EACZ,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B","sourcesContent":["mat-dialog-content {\n  min-height: 400px;\n}\n\n.my-video-draft p {\n  padding: 15px 0 0 0;\n  color: rgba(136, 133, 142, 1);\n}\n\n.my-video-draft .tab-box-video {\n  width: 100%;\n  margin-top: 20px;\n}\n\n.my-video-draft .tab-box-video ul {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n.my-video-draft .tab-box-video ul li {\n  list-style: none;\n  font-weight: 500;\n  font-size: 18px;\n  padding: 5px 0;\n  margin: 0px 25px;\n  color: #878395;\n  cursor: pointer;\n}\n\n::ng-deep .createBadge {\n  overflow: auto !important;\n}\n\n.my-video-draft .tab-box-video ul li.active {\n  border-top: 3px solid rgba(108, 47, 187, 1);\n  color: rgba(108, 47, 187, 1);\n}\n\n.folderImg {\n  object-fit: contain !important;\n}\n\n.example-card {\n  margin: 1rem 0 0.5rem 0;\n  cursor: pointer;\n}\n\n.selected-video {\n  border: 2px solid #6e5eff;\n  border-radius: 5px;\n}\n\n.addPathVideos {\n  text-align: end;\n}\n\n.addPathVideos button{\n  border: 1px solid #6e5eff;\n  padding: 8px 30px;\n  border-radius: 5px;\n  color: #ffff;\n  font-size: 15px;\n  cursor: pointer;\n  outline: none;\n  background: #6e5eff;\n}\n\n.selected-video .check-icon {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  z-index: 999999;\n  color: #6e5eff;\n  font-size: 36px;\n  background-color: white;\n  border-radius: 100%;\n}\n\nol li {\n  font-size: 18px;\n}\n\n.breadcrumb-item.active {\n  color: #6c2fbb !important;\n  font-weight: 500;\n}\n\n.firstLi {\n  cursor: pointer;\n}\n\n.docCard {\n  width: 190px;\n}\n\n.docCard img {\n  width: 190px;\n  height: 175px;\n  margin: 0;\n  touch-action: auto !important;\n}\n\n.docCard p {\n  text-align: center;\n  padding: 2px;\n  cursor: text;\n  font-weight: 500;\n  font-size: 15px;\n  color: #000;\n}\n\n.example-full-width {\n  width: 100%;\n}\n\nmat-card img {\n  object-fit: cover;\n  height: 165px;\n}\n\n.contain {\n  object-fit: contain !important;\n}\n\n.video-title {\n  word-break: break-word;\n  font: 400 14px/20px Roboto, \"Helvetica Neue\", sans-serif;\n  margin-bottom: 0 !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n#vid-search-btn {\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 9;\n}\n\n.select-vid-area {\n  border: 1px dotted black;\n  border-radius: 10px;\n  padding: 28px 15px;\n}\n\n.video-duration {\n  position: absolute;\n  left: 0;\n  top: 0;\n  background: lightgray;\n  padding-left: 4px;\n  padding-right: 4px;\n  color: black;\n  z-index: 1;\n}\n\n.FF-scroll-modify {\n  max-height: 600px;\n  height: auto;\n  overflow-x: hidden;\n  overflow-y: scroll;\n}\n\n.selected-item {\n  background-color: #ccc;\n  padding: 0px 21px;\n  height: 224px;\n}\n\n.button-style-dropdown {\n  border: 1px solid #6e5eff;\n  padding: 8px 30px;\n  border-radius: 5px;\n  color: #ffff;\n  font-size: 15px;\n  display: block;\n  width: 100%;\n  margin: 0 auto;\n  cursor: pointer;\n  position: relative;\n  outline: none;\n  background: #6e5eff;\n  text-align: center;\n}\n\n.btnUpload{\n    padding: 6px 10px !important;\n}\n\n.button-style-dropdown input {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9;\n  cursor: pointer;\n}\n\n.preview-card {\n  width: 100%;\n  margin-bottom: 8px;\n  cursor: pointer;\n}\n\n.preview-card img {\n  height: 150px;\n  width: 200px;\n}\n\n.btn-mania {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /*flex-wrap: wrap;*/\n  gap: 10px;\n  max-width: 360px;\n  /*margin: 30px auto 0;*/\n  margin: 0px auto 0;\n}\n\n.btn-mania button {\n  color: #6c2fbb;\n  border: 1px solid #6c2fbb;\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  background: #FFFFFF;\n  border-radius: 11px;\n  white-space: nowrap;\n}\n\n.cardForQue{\n  display: flex;\n  justify-content: center;\n  padding: 20px;\n}\n\n.cardForQue .badgeBoxForQue{\n    display: flex;\n    justify-content: center;\n    margin: auto;\n    align-items: center;\n}\n\n.mat-mdc-card-content:last-child{\n  padding: 0;\n}\n\n.cardForAIVideo{\n  cursor: inherit;\n}\n\n@media (max-width: 1199px) {\n  .videosModal>div {\n    padding-inline: 4px;\n  }\n\n  .videosModal>div .button-style-dropdown {\n    padding: 6px 5px;\n  }\n}\n\n@media only screen and (max-width: 991px) and (min-width: 768px)  {\n  ::ng-deep .recordSection {\n    max-width: 100% !important;\n    margin: auto;\n    display: flex;\n    width: 65% !important;\n    justify-content: center;\n  }\n}\n\n@media only screen and (max-width: 767px) and (min-width: 0px)  {\n  ::ng-deep .recordSection {\n    max-width: 100% !important;\n    margin: auto;\n    display: flex;\n    width: 90% !important;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .my-video-draft .tab-box-video ul li {\n    font-size: 17px;\n  }\n\n  .my-video-draft p {\n    font-size: 15px;\n  }\n}\n\n.privacy-text {\n  position: absolute;\n  /*left: 0;*/\n  top: 0;\n}\n\nmat-dialog-content {\n  overflow: hidden;\n}\n\nmat-dialog-content .FF-scroll-modify {\n  max-height: 350px;\n}\n\n@media (max-width: 720px) {\n  .videosModal {\n    flex-direction: column;\n    gap: 10px;\n  }\n}\n\n@media only screen and (max-width: 575px) and (min-width: 320px) {\n  mat-dialog-content {\n    padding: 0 10px;\n    margin: 0;\n  }\n\n  .videosModal {\n    gap: 10px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .videosModal .col-md-4 {\n    padding: 0;\n  }\n\n  .documents-scroll {\n    justify-content: center;\n  }\n\n  ::ng-deep .my-dialog {\n    width: 100% !important;\n    max-width: 95vw !important;\n  }\n\n  .mainSection {\n    gap: 10px;\n  }\n}\n\n@media (max-width: 420px) {\n  ::ng-deep .recordSection .mat-dialog-container {\n    padding: 14px;\n  }\n\n  ::ng-deep .recordSection .mat-dialog-container .custom-control label:first-child {\n    font-size: 14px;\n  }\n\n  .my-video-draft .tab-box-video ul li {\n    margin: 0px 18px;\n  }\n}\n\n\n\n/* Custom tooltip css start */\n.wrapper {\n    position: relative;\n    -webkit-transform: translateZ(0);\n    -webkit-font-smoothing: antialiased;\n    z-index: 2;\n}\n\n.wrapper .tooltip {\n  background: #505259eb;\n  bottom: 100%;\n  color: #fff;\n  display: block;\n  left: -20px;\n  margin-bottom: 15px;\n  opacity: 0;\n  padding: 10px;\n  pointer-events: none;\n  position: absolute;\n  width: 100%;\n  transform: translateY(10px);\n  transition: all .25s ease-out;\n  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);\n  border-radius: 6px;\n  z-index: 1;\n}\n\n.wrapper .tooltip:before {\n  bottom: -20px;\n  content: \" \";\n  display: block;\n  height: 20px;\n  left: 0;\n  position: absolute;\n  width: 100%;\n}\n\n.wrapper .tooltip:after {\n  border-left: solid transparent 10px;\n  border-right: solid transparent 10px;\n  border-top: solid #505259eb 10px;\n  bottom: -10px;\n  content: \" \";\n  height: 0;\n  left: 50%;\n  margin-left: -13px;\n  position: absolute;\n  width: 0;\n}\n\n.wrapper:hover .tooltip {\n  opacity: 1;\n  pointer-events: auto;\n  transform: translateY(0px);\n}\n\n.lte8 .wrapper .tooltip {\n  display: none;\n}\n\n.lte8 .wrapper:hover .tooltip {\n  display: block;\n}\n\n/* Custom tooltip css end */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
